module.exports = __webpack_public_path__ + "static/media/banner_bg.d48e43e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_bg.svg
// module id = 186
// module chunks = 1